import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <section
      data-testid="not-found-page"
      className="min-h-[70vh] grid place-items-center px-4"
    >
      <div className="text-center max-w-md">
        <div className="rk-eyebrow justify-center">404</div>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold text-[#0F172A]">
          Page not found
        </h1>
        <p className="mt-3 text-[#475569]">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Button
          asChild
          className="mt-8 bg-[#1E3A8A] hover:bg-[#1E3A8A]/90 text-white rounded-sm"
        >
          <Link to="/" data-testid="not-found-home-link">
            Go back home
          </Link>
        </Button>
      </div>
    </section>
  );
}
